function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarketplace = function SvgMarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 400 400"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m298.56 339.9-13.83-156.2h-8.49L251.3 370.71l24.94-28.26 22.32-2.55z",
    style: {
      fill: "#d6cec5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73 184.37 132 171.74l-17.25 7.55 161.39 11.86 8.59-6.78z",
    style: {
      fill: "#99897e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.58 131.43 1 169.59s-5.21 5.72-18.21 0l4.16-169.59Z",
    style: {
      fill: "#9da6aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 131.43h-21.33v-19.76s-.52-5.21 6.24-5.21H244s5.72 0 5.72 5.21c.54 4.68.54 19.76.54 19.76Z",
    style: {
      fill: "#d7dcde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74 159.23c8.21 6.72 20 17.47 22.46 30.68 2.62 13-8.6 22.18-17.28 23s-23.39-15.52-27.35-29.59S188.81 143 188.81 143a36.1 36.1 0 0 0 10.93 16.23Z",
    style: {
      fill: "#23c388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76 227.4c1.94-6.73-.85-33.54-2.08-38.18s-9.83-17.47-3.72-17.86 10.45 19.8 12.54 26.9c2 6.72 1.08 25.82 1.08 25.82s10.38-3.8 22.23-6.75 21.14-1.48 24.08.22-5.74 2.56-10.38 3.8-25 4.8-32.22 10.44-10.84 15.31-10.84 15.31C200 253 191.2 275 191.2 275c-11 1.48-10.53-6.1-10.53-6.1s20.15-34.77 22.09-41.5Z",
    style: {
      fill: "#009e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.2 81.78s7.17 29.43-.6 41.81-26.5 23.94-34.6 20.67-16.23-15.26-10-27c6.11-12 20.43-19 30.21-23.09a36.16 36.16 0 0 0 14.99-12.39ZM69.74 133.85S86 119.4 99.91 117.76s25.66 2.49 32.05 13.17c6.11 10.75.57 19.09-6.67 24.06-7.72 5.38-18.7 4.56-28.79-7-9.82-11.56-26.76-14.14-26.76-14.14Z",
    style: {
      fill: "#23c388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48 204.79s-1.7 7.4-11.83 2.88c0 0-2.26-23.63-3.87-30.23 0 0-.76-10.31-6.07-17.75s-23.86-16.63-28-19.12-12.18-5.77-8.88-6.58 12.63.42 23.16 6.59 19.43 12.75 19.43 12.75 4.5-18.57 8.31-24.46c4-6.22 13.88-24.35 19.64-22.26s-6.12 12-8.61 16.08-12.74 29-12.79 36 9.51 46.1 9.51 46.1Z",
    style: {
      fill: "#009e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.89 179.29 83.47 349.51l167.83 21.2 24.67-179.56-161.08-11.86z",
    style: {
      fill: "#e9e3dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.21 200.32s-2.7 1.08-3.24-1.62 1.62-4.85 3.24-4.85 3.77 0 4.31 2.69-1.08 4.86-4.31 3.78ZM160 199.78s-2.7 1.08-3.24-1.62 1.62-4.85 3.24-4.85 3.77 0 4.31 2.69-1.04 4.86-4.31 3.78Z",
    style: {
      fill: "#99897e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18 195.49a2.76 2.76 0 0 1 2.82 2.71v.12c0 2.83-2.83 43-1.42 48.38s4.25 22.39 15.57 22.39 25.48-11.32 31.14-28.31 14.15-39.63 14.15-42.46 8.5-5.66 2.84 11.32-14.16 42.46-22.65 51-14.15 17-31.14 14.15-17-31.14-17-39.63.03-39.67 5.69-39.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.71 116 302 219.73s5.35 2.29 4.06-1.8-40.35-89.81-40.35-89.81-10.71 3.78-15.64-.12-11.27-13.92-11.27-13.92Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.94 115.61-123.68 5.92s-4.49 3.4-.79 4.21c4.22.79 97.62 11.3 97.62 11.3s2.46-11.1 8-13.52c6.14-1.93 17.56-2.62 17.56-2.62Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.44 123.92 56.39-110.25S296 8 293 11.29s-58.28 79.1-58.28 79.1 8.29 7.83 7.6 13.61c-1.18 6.32-6.3 16.53-6.3 16.53Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.14,
    cy: 119.84,
    r: 9.36,
    style: {
      fill: "#fff"
    },
    transform: "rotate(-3.46 239.123 119.895)"
  }));
};
export default SvgMarketplace;